import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginApi } from "../redux/login/loginApiCalls";
import { State } from "../redux/store";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ShowErrorMsg from "../HtmlComponents/ShowErrorMsg";
import { InputElement } from "../HtmlComponents/InputElement";

const Login: React.FC = () => {
  const { userData } = useSelector((state: State) => state.login);
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { t } = useTranslation();

  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loginType, setLoginType] = useState<string>("Admin");
  const [errors, setErrors] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const submitLogin = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response: any = await dispatch(loginApi({ username, password, loginType }));
      response === true ? setErrors([]) : setErrors(response);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      setErrors([]);
      userData.doctor ? navigate(`/doctor/${userData._id}/about/regform`) : navigate("/", { replace: true });
    }
  }, [navigate, userData]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 p-6">
      <div className="w-full max-w-md bg-white shadow-xl rounded-lg p-8">
        {/* Logo */}
        <div className="flex justify-center mb-4">
          <img src="/assets/images/ASOFT.png" alt="dentist-logo" className="h-16" />
        </div>

        {/* Switch entre Administrations & Docteurs */}
        <div className="grid grid-cols-2 mb-4 border rounded-lg overflow-hidden">
          {["Admin", "Docteur"].map((type) => (
            <button
              key={type}
              className={`py-2 font-semibold text-center transition-all ${
                loginType === type ? "bg-main text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
              onClick={() => setLoginType(type)}
            >
              {type === "Admin" ? t("Gestion & Administration") : t("Espace Médecins")}
            </button>
          ))}
        </div>

        {/* Formulaire */}
        <form onSubmit={submitLogin} className="space-y-4">
          <InputElement name={t("Username")} placeholder={t("Username")} value={username} setValue={setUsername} />
          <InputElement type="password" name={t("Password")} placeholder={t("Password")} value={password} setValue={setPassword} />

          {/* Bouton Connexion */}
          <button
            className="w-full flex items-center justify-center py-2 px-4 font-bold text-white bg-main rounded-lg shadow-md transition hover:bg-main-dark disabled:bg-gray-400"
            disabled={loading}
          >
            {loading ? <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div> : t("Connecter")}
          </button>
        </form>

        {/* Lien Retour */}
        <p className="mt-4 text-sm text-center text-gray-600 hover:text-gray-900 cursor-pointer underline" onClick={() => navigate("/")}>
          {t("retourner à la page d'accueil")}
        </p>

        {/* Affichage des erreurs */}
        <ShowErrorMsg errors={errors} setErrors={setErrors} />
      </div>
    </div>
  );
};

export default Login;
